import React, { useState, useEffect, useRef } from 'react';
import './Stats.css';

const defaultStats = [
  { title: 'Rating', value: 4.8 },
  { title: 'Students Trained', value: 5000 },
  { title: 'Reviews', value: 250 },
  { title: 'Offerings', value: 15 },
  
 
];

const easeOutQuart = (t) => 1 - (1 - t) ** 4;

const Stats = ({ stats: propStats }) => {
  const stats = propStats && propStats.length === 4 ? propStats : defaultStats;
  const [displayValues, setDisplayValues] = useState(stats.map(() => 0));
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated) {
          setHasAnimated(true);
        }
      },
      { threshold: 0.2, rootMargin: '0px 0px -50px 0px' }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [hasAnimated]);

  useEffect(() => {
    if (!hasAnimated) return;

    const duration = 1800;
    const startTime = performance.now();

    const tick = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeOutQuart(progress);

      setDisplayValues(
        stats.map((stat) => {
          const target = typeof stat.value === 'number' ? stat.value : parseFloat(stat.value) || 0;
          const isDecimal = target % 1 !== 0;
          const current = isDecimal ? Number((target * eased).toFixed(1)) : Math.round(target * eased);
          return current;
        })
      );

      if (progress < 1) {
        requestAnimationFrame(tick);
      }
    };

    requestAnimationFrame(tick);
  }, [hasAnimated, stats]);

  const formatValue = (stat, index) => {
    const raw =
      typeof stat.value === 'number' && stat.value % 1 !== 0
        ? displayValues[index].toFixed(1)
        : displayValues[index];

    if (stat.title === 'Reviews' || stat.title === 'Students Trained' || stat.title === 'Offerings') {
      return `${raw}+`;
    }

    if (stat.title === 'Success Rate') {
      return `${raw}%`;
    }

    if (stat.title === 'Rating') {
      return (
        <>
          {raw}
          <span className="stats-star" aria-hidden="true">
            ★
          </span>
        </>
      );
    }

    return raw;
  };

  return (
    <section className="stats-section" ref={sectionRef} aria-label="Statistics">
      <div className="stats-container">
        {stats.map((stat, i) => (
          <div key={i} className="stats-item">
            <span className="stats-number" data-value={stat.value} aria-label={`${stat.value} ${stat.title}`}>
              {formatValue(stat, i)}
            </span>
            <span className="stats-title">{stat.title}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
